var _path, _path2, _g, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3192 22H6.43324C3.98924 22 2.00024 20.011 2.00024 17.565V6.436C2.00024 3.99 3.98924 2 6.43324 2H11.3082C13.7542 2 15.7442 3.99 15.7442 6.436V7.368C15.7442 7.782 15.4082 8.118 14.9942 8.118C14.5802 8.118 14.2442 7.782 14.2442 7.368V6.436C14.2442 4.816 12.9272 3.5 11.3082 3.5H6.43324C4.81624 3.5 3.50024 4.816 3.50024 6.436V17.565C3.50024 19.184 4.81624 20.5 6.43324 20.5H11.3192C12.9312 20.5 14.2442 19.188 14.2442 17.576V16.633C14.2442 16.219 14.5802 15.883 14.9942 15.883C15.4082 15.883 15.7442 16.219 15.7442 16.633V17.576C15.7442 20.016 13.7582 22 11.3192 22Z",
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33437_4791",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 15,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99609 11.25H22.537V12.75H8.99609V11.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33437_4791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7871 12.75H9.74609C9.33209 12.75 8.99609 12.414 8.99609 12C8.99609 11.586 9.33209 11.25 9.74609 11.25H21.7871C22.2011 11.25 22.5371 11.586 22.5371 12C22.5371 12.414 22.2011 12.75 21.7871 12.75Z",
    fill: "#616161"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_33437_4791",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 5,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1096 8.33521H22.537V15.666H18.1096V8.33521Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_33437_4791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8594 15.666C18.6674 15.666 18.4744 15.593 18.3284 15.445C18.0364 15.151 18.0374 14.677 18.3304 14.385L20.7244 12L18.3304 9.61596C18.0374 9.32396 18.0354 8.84996 18.3284 8.55596C18.6204 8.26196 19.0944 8.26196 19.3884 8.55396L22.3164 11.469C22.4584 11.609 22.5374 11.801 22.5374 12C22.5374 12.199 22.4584 12.391 22.3164 12.531L19.3884 15.447C19.2424 15.593 19.0504 15.666 18.8594 15.666Z",
    fill: "#616161"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.ad97b332050ee24d647c50242a281938.svg";
export { ForwardRef as ReactComponent };